import ajax from '../../api/account'
import * as types from '../mutation-types'
import * as utils from '../../libs/utils'

const state = {
  balance:'',
  formatBalance:''
}

const getters = {}

const actions = {
  setBalance ({ commit }) {
    //获取余额
    ajax.getBalance().then(data => {
      if (data&&data.flag) { 
          let balanceObj={
            balance: data.data,
            formatBalance: utils.formatMoney(data.data/100,2)
          }
          commit(types.SET_BALANCE,balanceObj)
      } 
    })
    
  }
}

const mutations = {
  [types.SET_BALANCE] (state,balanceObj) {
    state.balance = balanceObj.balance
    state.formatBalance = balanceObj.formatBalance
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./app/store/modules/balance.js